import { Box, CircularProgress } from '@mui/material'

const LoadingCircular = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
      }}
    >
      <CircularProgress size={50} />
    </Box>
  )
}

export default LoadingCircular
